import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import PublicLayout from '../../components/PublicLayout';
import { useAuthContext } from '../../contexts/AuthContext';

interface BlogArticleLayoutProps {
  title: string;
  date: string;
  readTime: string;
  children: ReactNode;
}

export default function BlogArticleLayout({
  title,
  date,
  readTime,
  children,
}: BlogArticleLayoutProps) {
  const { isAuthenticated } = useAuthContext();

  return (
    <PublicLayout>
      <div className="bg-gradient-to-br from-blue-600 via-purple-600 to-purple-700 text-white py-16 px-4">
        <div className="max-w-3xl mx-auto">
          <Link
            to="/blog"
            className="inline-flex items-center text-purple-200 hover:text-white transition-colors text-sm mb-4"
          >
            &larr; Back to Blog
          </Link>
          <h1 className="text-3xl sm:text-4xl font-bold mb-4">{title}</h1>
          <div className="flex items-center gap-3 text-purple-200 text-sm">
            <span>By Takedown League</span>
            <span>|</span>
            <time dateTime={date}>
              {new Date(date + 'T00:00:00').toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              })}
            </time>
            <span>|</span>
            <span>{readTime}</span>
          </div>
        </div>
      </div>

      <article className="bg-white py-12 px-4">
        <div className="max-w-3xl mx-auto prose prose-gray prose-lg prose-headings:text-gray-900 prose-a:text-purple-600 prose-a:no-underline hover:prose-a:underline prose-li:text-gray-700 prose-p:mb-6 prose-headings:mt-10 prose-headings:mb-4 prose-ul:mb-6 prose-li:mb-2">
          {children}
        </div>
      </article>

      <section className="bg-gradient-to-r from-blue-600 via-purple-600 to-purple-700 py-12 px-4">
        <div className="max-w-3xl mx-auto text-center">
          {isAuthenticated ? (
            <>
              <h2 className="text-3xl font-bold text-white mb-4">Ready to Compete?</h2>
              <p className="text-purple-100 mb-6">
                Head back to your leagues and put these insights to work.
              </p>
              <Link
                to="/leagues"
                className="inline-block bg-white text-purple-700 font-semibold py-3 px-8 rounded-lg hover:bg-purple-50 transition-colors text-lg"
              >
                Back to My Leagues
              </Link>
            </>
          ) : (
            <>
              <h2 className="text-3xl font-bold text-white mb-4">Ready to Play?</h2>
              <p className="text-purple-100 mb-6">
                Create your free account and start drafting your wrestling roster today.
              </p>
              <Link
                to="/login?tab=register"
                className="inline-block bg-white text-purple-700 font-semibold py-3 px-8 rounded-lg hover:bg-purple-50 transition-colors text-lg"
              >
                Create Your Free Account
              </Link>
            </>
          )}
        </div>
      </section>
    </PublicLayout>
  );
}
